export const workspaceKey_OrderEditor = 'workspace__manager-order';
export const WorkspaceConfig_OrderEditor = {
    name: workspaceKey_OrderEditor,
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'selector', visible: true, factor: 1.5 / 5, min: 450,
                data: {}
            },
            {
                name: 'RightPanel', key: 'presenter', visible: true, factor: 3.5 / 5, min: 1100,
                data: {}
            },
        ]
    }
};
//# sourceMappingURL=workspace-config.js.map